const columns = [
  {
    title: "تاریخ ثبت",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 130,
    sorter: true,
  },
  {
    title: "کاربر",
    dataIndex: "user",
    key: "user",
    width: 160,
    ellipsis: true,
  },
  {
    title: "مبلغ (ریال)",
    dataIndex: "amount",
    key: "amount",
    width: 140,
    sorter: true,
  },
  {
    title: "تاریخ شروع",
    dataIndex: "startAt",
    key: "startAt",
    width: 160,
    ellipsis: true,
    sorter: true,
  },
  {
    title: "تاریخ پایان",
    dataIndex: "endAt",
    key: "endAt",
    width: 160,
    ellipsis: true,
    sorter: true
  },
  {
    title: "توضیحات",
    dataIndex: "description",
    key: "description",
    ellipsis: true,
  },
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
    width: 140,
  },
];

export default columns;
